import {DfEntryStatus} from "shared/types/common";

export type ColumnSizes = Record<string, number>;

export const computeColumnSizes = (columns: string[], rows: Record<string, string|number|DfEntryStatus|string[]|undefined>[]) => {
    let generalLength = 0
    const colSizes: ColumnSizes = {};

    for (let col of columns){
        if (col === 'URL') {
            continue;
        }

        let currLen = col.length + 5;
        for (let row of rows){
            let cellVal = row[col]?.toString() ?? 'MISSING';
            if (/^https?:\/\//.test(cellVal)){
                try {
                    cellVal = cellVal.split('&')[1].split('=')[1];
                } catch (e) {
                    console.log("Unexpected URL: " + cellVal);
                }
            }
            const newLen = cellVal.length;
            if (newLen > currLen) {
                currLen = newLen;
            }
        }

        generalLength += currLen + 2;
        colSizes[col] = currLen;
    }

    colSizes['Row'] = Math.max(rows.length.toString().length, 5);
    generalLength += colSizes['Row'] + 2;

    colSizes['generalLength'] = generalLength;

    return colSizes;
}